import { API } from "./baseService";
import APP_CONST from "../../core/shared/constants";

export const doFetchRoleListView = () => {
  const contextPath = APP_CONST.API.GET_ROLELIST;
  return API.get(contextPath);
};

export const doFetchDBCheck = () => {
  const contextPath = APP_CONST.API.GET_DB_CHECK;
  return API.get(contextPath, { type: "baseTemplateUrl" });
};
